import Axios from 'axios'
import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import clientsConf from './clients/index'
import router from './router'
import store from './store'
// import './registerServiceWorker'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing);

Vue.config.productionTip = false

Vue.prototype.$axios = Axios
Vue.prototype.$config = clientsConf[process.env.VUE_APP_CLIENT].conf



Vue.filter('columns', (v) => {
  let out = `col-xs-12 col-sm-12 col-lg-${Math.floor(12/parseInt(v))} portfolio-item`
  return out
})

Vue.component('v-style', clientsConf[process.env.VUE_APP_CLIENT].commonStyle)




Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
})

const COOKIE_MODAL_LABEL_ID = 'cookieConsentModalLabel'
const COOKIE_MODAL_SELECTOR = `h4#${COOKIE_MODAL_LABEL_ID}`
const COOKIE_MODAL_TITLE_SELECTORS = [
  `#${COOKIE_MODAL_LABEL_ID}`,
  '.cookie-modal-title',
  '.cookie-consent_modal__title',
  '.cookie-consent_modal__header h1',
  '.cookie-consent_modal__header h2',
  '.cookie-consent_modal__header h3',
  '.cookie-consent_modal__header p',
  'h1, h2, h3, h4, h5, h6',
  'p'
]

const ensureDialogAccessibleName = (dialog) => {
  if (!dialog || dialog.nodeType !== 1) return
  if (!dialog.hasAttribute('role') || !['dialog', 'alertdialog'].includes(dialog.getAttribute('role'))) return

  const hasLabelledBy = dialog.getAttribute('aria-labelledby')
  const hasLabel = dialog.getAttribute('aria-label')
  if (hasLabelledBy || hasLabel) return

  let titleEl = null
  for (const selector of COOKIE_MODAL_TITLE_SELECTORS) {
    titleEl = dialog.querySelector(selector)
    if (titleEl) break
  }

  if (titleEl) {
    if (!titleEl.id) {
      titleEl.id = 'cookie-consent-modal-title'
    }
    dialog.setAttribute('aria-labelledby', titleEl.id)
    dialog.removeAttribute('aria-label')
    return
  }

  const text = dialog.textContent ? dialog.textContent.trim().replace(/\s+/g, ' ') : ''
  if (text) {
    dialog.setAttribute('aria-label', text.slice(0, 120))
  }
}

const REQUIRED_PARENT_ROLES = {
  listitem: ['list'],
  option: ['listbox'],
  treeitem: ['tree'],
  menuitem: ['menu', 'menubar'],
  menuitemcheckbox: ['menu', 'menubar'],
  menuitemradio: ['menu', 'menubar'],
  tab: ['tablist'],
  radio: ['radiogroup'],
  row: ['rowgroup', 'grid', 'table'],
  rowgroup: ['grid', 'table'],
  gridcell: ['row'],
  cell: ['row'],
  columnheader: ['row'],
  rowheader: ['row']
}

const removeRoleFromExternalWidget = (rootNode) => {
  if (typeof document === 'undefined') return

  const candidates = []
  if (rootNode && rootNode.nodeType === 1) {
    if (rootNode.classList && rootNode.classList.contains('Qr7Oae')) {
      candidates.push(rootNode)
    }
    if (rootNode.querySelectorAll) {
      rootNode.querySelectorAll('.Qr7Oae').forEach((el) => candidates.push(el))
    }
  } else {
    document.querySelectorAll('.Qr7Oae').forEach((el) => candidates.push(el))
  }

  candidates.forEach((el) => {
    if (el.hasAttribute('role')) {
      el.removeAttribute('role')
    }
  })
}

const fixInvalidAriaChildRoles = (rootNode) => {
  if (typeof document === 'undefined') return

  const roleSelectors = Object.keys(REQUIRED_PARENT_ROLES)
    .map((role) => `[role="${role}"]`)
    .join(',')

  const candidates = []
  if (rootNode && rootNode.nodeType === 1) {
    if (rootNode.hasAttribute && rootNode.hasAttribute('role')) {
      candidates.push(rootNode)
    }
    if (rootNode.querySelectorAll) {
      rootNode.querySelectorAll(roleSelectors).forEach((el) => candidates.push(el))
    }
  } else {
    document.querySelectorAll(roleSelectors).forEach((el) => candidates.push(el))
  }

  candidates.forEach((el) => {
    const role = el.getAttribute('role')
    if (!role) return
    const requiredParents = REQUIRED_PARENT_ROLES[role]
    if (!requiredParents) return
    const hasRequiredParent = requiredParents.some((parentRole) =>
      el.closest(`[role="${parentRole}"]`)
    )
    if (!hasRequiredParent) {
      el.removeAttribute('role')
    }
  })
}

const replaceCookieModalTitle = (rootNode) => {
  if (typeof document === 'undefined') return

  let target = null

  if (rootNode && rootNode.nodeType === 1) {
    if (rootNode.matches && rootNode.matches(COOKIE_MODAL_SELECTOR)) {
      target = rootNode
    } else if (rootNode.querySelector) {
      target = rootNode.querySelector(COOKIE_MODAL_SELECTOR)
    }
  }

  if (!target) {
    target = document.querySelector(COOKIE_MODAL_SELECTOR)
  }

  if (!target || !target.parentNode) return

  const replacement = document.createElement('p')
  Array.from(target.attributes).forEach((attr) => {
    replacement.setAttribute(attr.name, attr.value)
  })
  replacement.classList.add('cookie-modal-title')
  replacement.innerHTML = target.innerHTML

  target.parentNode.replaceChild(replacement, target)
  const dialog = replacement.closest ? replacement.closest('[role="dialog"], [role="alertdialog"]') : null
  if (dialog) ensureDialogAccessibleName(dialog)
}

new Vue({
    router,
    store,
    render: h => h(App),
    mounted() {
      const applyA11yFixes = (root) => {
        replaceCookieModalTitle(root)
        document.querySelectorAll('[role="dialog"], [role="alertdialog"]').forEach((dialog) => {
          ensureDialogAccessibleName(dialog)
        })
        removeRoleFromExternalWidget(root)
        fixInvalidAriaChildRoles(root)
      }

      applyA11yFixes(document.body)
      setTimeout(() => applyA11yFixes(document.body), 300)
      setTimeout(() => applyA11yFixes(document.body), 1000)
      setTimeout(() => applyA11yFixes(document.body), 2500)

      if (typeof MutationObserver === 'undefined') return

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            applyA11yFixes(node)
            if (node && node.nodeType === 1) {
              if (node.matches && node.matches('[role="dialog"], [role="alertdialog"]')) {
                ensureDialogAccessibleName(node)
              } else if (node.querySelector) {
                node.querySelectorAll('[role="dialog"], [role="alertdialog"]').forEach((dialog) => {
                  ensureDialogAccessibleName(dialog)
                })
              }
            }
          })
          if (mutation.type === 'attributes' && mutation.attributeName === 'role') {
            const target = mutation.target
            if (target && target.nodeType === 1) {
              removeRoleFromExternalWidget(target)
              fixInvalidAriaChildRoles(target)
            }
          }
        })
      })

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['role']
      })
    }
}).$mount('#app', true)
